import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Public web config for the shared `vore-4587e` Firebase project (public by
// design) — `firebase apps:sdkconfig WEB` for app "Vore Web".
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDvZNHZE-cUOGuSCy-xkevdLWOhvFYSpvU',
  authDomain: 'vore-4587e.firebaseapp.com',
  projectId: 'vore-4587e',
  storageBucket: 'vore-4587e.appspot.com',
  messagingSenderId: '200811042905',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:200811042905:web:4e13e512c530bacd91b948',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-1DXXVBPY85',
}

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

// Offline persistence (IndexedDB). ignoreUndefinedProperties matches the mobile
// writers' strip-undefined behavior — entries carry optional keys.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
})

export const functions = getFunctions(app)
export const storage = getStorage(app)

void setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory if storage is unavailable */
})

export const googleProvider = new GoogleAuthProvider()

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
